import type { FC } from 'react';
import type { CreatorRemoteProps } from '@/types/creator.mf.ts';
import Layout from './components/Layout';
import useStepperApp from './hooks/useStepperApp';
import StepperOnboardingPage from './StepperOnboardingPage';

interface StepperAppProps {
	actor?: CreatorRemoteProps['actor'];
}

const StepperApp: FC<StepperAppProps> = ({ actor }) => {
	useStepperApp(actor);

	return (
		<Layout>
			<StepperOnboardingPage actor={actor} />
		</Layout>
	);
};

export default StepperApp;
